import { render } from "./ViolationDetailView.vue?vue&type=template&id=82d95630&scoped=true"
import script from "./ViolationDetailView.vue?vue&type=script&lang=js"
export * from "./ViolationDetailView.vue?vue&type=script&lang=js"

import "./ViolationDetailView.vue?vue&type=style&index=0&id=82d95630&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d95630"]])

export default __exports__